import { render } from "./EditResumeSkeleton.vue?vue&type=template&id=207d9872&scoped=true"
const script = {}

import "./EditResumeSkeleton.vue?vue&type=style&index=0&id=207d9872&scoped=true&lang=css"

import exportComponent from "D:\\CODE\\joyjobs_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-207d9872"]])

export default __exports__